// ProtectedRoute.tsx
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { AppDispatch } from '../store/store';
import { setCurrentUser } from '../features/user/userSlice';
import useToken from '../hooks/useToken';
import { getProfileInfo } from 'src/features/notifications/utils';

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ redirectPath = '/auth/sign-in' }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { decodedToken, loading, tokenString } = useToken();

  useEffect(() => {
    if (decodedToken) {
      dispatch(
        setCurrentUser({
          user: { ...decodedToken, accessToken: tokenString },
          accessToken: tokenString,
        }),
      );

      dispatch(getProfileInfo()).then((result) => {
        if (getProfileInfo.fulfilled.match(result)) {
          dispatch(
            setCurrentUser({
              user: { ...result.payload, accessToken: tokenString },
              accessToken: tokenString,
            }),
          );
        }
      });

      if (!decodedToken.teamRole) {
        const pendoMetadataPayload = {
          visitor: {
            id: decodedToken.customerId,
            email: decodedToken.email,
            profileSeniority: decodedToken.role,
            registrationDayTime: decodedToken.createdAt,
          },
          account: {
            id: decodedToken.organization.customerId,
            organizationType: decodedToken.organization.type,
            source: decodedToken.organization.discoverySource,
            name: decodedToken.organization.name
          },
        };
        //@ts-ignore
        window.pendo && window.pendo.initialize(pendoMetadataPayload);
      }
    }
  }, [decodedToken]);

  if (loading) {
    return null;
  }

  if (!decodedToken) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export { ProtectedRoute };
